"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(wrap),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(arrayFromArray),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(arrayFromCodecArrayValue),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(arrayFromTypeValueInput),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(arrayFailureCase),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(tupleFromArray),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(tupleFromObject),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(tupleFromCodecTupleLikeValue),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(tupleFromTypeValueInput),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(tupleFailureCase),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(udvtFromUnderlying),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(optionsFromObject),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(optionsFromCodecOptionsValue),
    _marked14 = /*#__PURE__*/_regeneratorRuntime.mark(optionsFromTypeValueInput),
    _marked15 = /*#__PURE__*/_regeneratorRuntime.mark(optionsFailureCase);

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrap = exports.udvtCases = exports.txOptionsCases = exports.tupleCases = exports.arrayCases = void 0;

var debug_1 = __importDefault(require("debug"));

var debug = debug_1.default("codec:wrap:wrap");

var Format = __importStar(require("../format"));

var errors_1 = require("./errors");

var dispatch_1 = require("./dispatch");

var Messages = __importStar(require("./messages"));

var Conversion = __importStar(require("../conversion"));

var Utils = __importStar(require("./utils"));

var integer_1 = require("./integer");

var decimal_1 = require("./decimal");

var bool_1 = require("./bool");

var bytes_1 = require("./bytes");

var address_1 = require("./address");

var string_1 = require("./string");

var function_1 = require("./function"); //this file contains the main wrap function, as well as the cases
//for arrays, tuples, udvts, and tx options.  all other types get their
//own file.


var arrayCasesBasic = [arrayFromArray, arrayFromCodecArrayValue, arrayFailureCase];
exports.arrayCases = [arrayFromTypeValueInput].concat(arrayCasesBasic);
var tupleCasesBasic = [tupleFromArray, tupleFromCodecTupleLikeValue, tupleFromObject, tupleFailureCase];
exports.tupleCases = [tupleFromTypeValueInput].concat(tupleCasesBasic);
var txOptionsCasesBasic = [optionsFromCodecOptionsValue, optionsFromObject, optionsFailureCase];
exports.txOptionsCases = [optionsFromTypeValueInput].concat(txOptionsCasesBasic);
exports.udvtCases = [//no separate case for udvtFromUdvtValue,
//since underlying already handles this
udvtFromUnderlying];

function wrap(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function wrap$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!wrapOptions.name) {
            wrapOptions = Object.assign(Object.assign({}, wrapOptions), {
              name: "<input>"
            });
          }

          _context.t0 = dataType.typeClass;
          _context.next = _context.t0 === "uint" ? 4 : _context.t0 === "int" ? 4 : _context.t0 === "enum" ? 4 : _context.t0 === "fixed" ? 6 : _context.t0 === "ufixed" ? 6 : _context.t0 === "bool" ? 8 : _context.t0 === "bytes" ? 10 : _context.t0 === "address" ? 12 : _context.t0 === "contract" ? 12 : _context.t0 === "string" ? 14 : _context.t0 === "function" ? 16 : _context.t0 === "array" ? 20 : _context.t0 === "struct" ? 22 : _context.t0 === "tuple" ? 22 : _context.t0 === "userDefinedValueType" ? 24 : _context.t0 === "options" ? 26 : 28;
          break;

        case 4:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, integer_1.integerCases), "t1", 5);

        case 5:
          return _context.abrupt("return", _context.t1);

        case 6:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, decimal_1.decimalCases), "t2", 7);

        case 7:
          return _context.abrupt("return", _context.t2);

        case 8:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, bool_1.boolCases), "t3", 9);

        case 9:
          return _context.abrupt("return", _context.t3);

        case 10:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, bytes_1.bytesCases), "t4", 11);

        case 11:
          return _context.abrupt("return", _context.t4);

        case 12:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, address_1.addressCases), "t5", 13);

        case 13:
          return _context.abrupt("return", _context.t5);

        case 14:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, string_1.stringCases), "t6", 15);

        case 15:
          return _context.abrupt("return", _context.t6);

        case 16:
          if (!(dataType.visibility === "internal")) {
            _context.next = 18;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, //it doesn't matter, but we'll make this error high specificity
          "Wrapping/encoding for internal function pointers is not supported");

        case 18:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, function_1.functionExternalCases), "t7", 19);

        case 19:
          return _context.abrupt("return", _context.t7);

        case 20:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, exports.arrayCases), "t8", 21);

        case 21:
          return _context.abrupt("return", _context.t8);

        case 22:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, exports.tupleCases), "t9", 23);

        case 23:
          return _context.abrupt("return", _context.t9);

        case 24:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, exports.udvtCases), "t10", 25);

        case 25:
          return _context.abrupt("return", _context.t10);

        case 26:
          return _context.delegateYield(dispatch_1.wrapWithCases(dataType, input, wrapOptions, exports.txOptionsCases), "t11", 27);

        case 27:
          return _context.abrupt("return", _context.t11);

        case 28:
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, //it doesn't matter, but we'll make this error high specificity
          "Wrapping/encoding for type ".concat(Format.Types.typeStringWithoutLocation(dataType), " is not supported"));

        case 29:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.wrap = wrap; //array cases

function arrayFromArray(dataType, input, wrapOptions) {
  var value, index;
  return _regeneratorRuntime.wrap(function arrayFromArray$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (Array.isArray(input)) {
            _context2.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not an array");

        case 2:
          if (!(dataType.kind === "static" && !dataType.length.eqn(input.length))) {
            _context2.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrongArrayLengthMessage(dataType.length, input.length));

        case 4:
          //can't do yield in a map, so manual loop here
          value = [];
          index = 0;

        case 6:
          if (!(index < input.length)) {
            _context2.next = 14;
            break;
          }

          _context2.t0 = value;
          return _context2.delegateYield(wrap(dataType.baseType, input[index], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, "[").concat(index, "]"),
            specificityFloor: 5 //errors in components are quite specific!

          })), "t1", 9);

        case 9:
          _context2.t2 = _context2.t1;

          _context2.t0.push.call(_context2.t0, _context2.t2);

        case 11:
          index++;
          _context2.next = 6;
          break;

        case 14:
          return _context2.abrupt("return", {
            type: dataType,
            kind: "value",
            value: value
          });

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function arrayFromCodecArrayValue(dataType, input, wrapOptions) {
  var value;
  return _regeneratorRuntime.wrap(function arrayFromCodecArrayValue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context3.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "array")) {
            _context3.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "value")) {
            _context3.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 6:
          if (!(!wrapOptions.loose && input.type.kind === dataType.kind)) {
            _context3.next = 8;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 8:
          //note that we do *not* just copy over input.value, but rather we
          //defer to arrayFromArray; this is because there might be some elements
          //where the type is not the same but is compatible
          value = input.value;
          return _context3.delegateYield(arrayFromArray(dataType, value, wrapOptions), "t0", 10);

        case 10:
          return _context3.abrupt("return", _context3.t0);

        case 11:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function arrayFromTypeValueInput(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function arrayFromTypeValueInput$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (Utils.isTypeValueInput(input)) {
            _context4.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a type/value pair");

        case 2:
          if (!(input.type !== "array")) {
            _context4.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.specifiedTypeMessage(input.type));

        case 4:
          return _context4.delegateYield(dispatch_1.wrapWithCases(dataType, input.value, wrapOptions, arrayCasesBasic), "t0", 5);

        case 5:
          return _context4.abrupt("return", _context4.t0);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function arrayFailureCase(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function arrayFailureCase$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 2, "Input was not an array, type/value pair or wrapped array");

        case 1:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
} //tuple/struct cases;
//note even with loose turned off, we won't distinguish
//between tuples and structs


function tupleFromArray(dataType, input, wrapOptions) {
  var memberTypes, value, index, memberName;
  return _regeneratorRuntime.wrap(function tupleFromArray$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (Array.isArray(input)) {
            _context6.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not an array");

        case 2:
          debug("input is array");
          memberTypes = memberTypesForType(dataType, wrapOptions.userDefinedTypes);

          if (!(memberTypes.length !== input.length)) {
            _context6.next = 7;
            break;
          }

          debug("input is wrong-length array");
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrongArrayLengthMessage(memberTypes.length, input.length));

        case 7:
          //can't do yield in a map, so manual loop here
          value = [];
          index = 0;

        case 9:
          if (!(index < input.length)) {
            _context6.next = 21;
            break;
          }

          memberName = memberTypes[index].name;
          debug("wrapping %s", memberName);
          _context6.t0 = value;
          _context6.t1 = memberName;
          return _context6.delegateYield(wrap(memberTypes[index].type, input[index], Object.assign(Object.assign({}, wrapOptions), {
            name: memberName ? wrapOptions.name.match(/^<.*>$/) //hack?
            ? memberName : "".concat(wrapOptions.name, ".").concat(memberName) : "".concat(wrapOptions.name, "[").concat(index, "]"),
            specificityFloor: 5
          })), "t2", 15);

        case 15:
          _context6.t3 = _context6.t2;
          _context6.t4 = {
            name: _context6.t1,
            value: _context6.t3
          };

          _context6.t0.push.call(_context6.t0, _context6.t4);

        case 18:
          index++;
          _context6.next = 9;
          break;

        case 21:
          return _context6.abrupt("return", {
            type: dataType,
            kind: "value",
            value: value
          });

        case 22:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function tupleFromObject(dataType, input, wrapOptions) {
  var memberTypes, unusedKeys, value, index, memberName, exampleKey;
  return _regeneratorRuntime.wrap(function tupleFromObject$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (Utils.isPlainObject(input)) {
            _context7.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a non-null object");

        case 2:
          if (!(!wrapOptions.loose && Utils.isTypeValueInput(input))) {
            _context7.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a type/value pair");

        case 4:
          if (!(!wrapOptions.loose && Utils.isWrappedResult(input))) {
            _context7.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a wrapped result");

        case 6:
          memberTypes = memberTypesForType(dataType, wrapOptions.userDefinedTypes);

          if (!memberTypes.some(function (_ref) {
            var name = _ref.name;
            return !name;
          })) {
            _context7.next = 9;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 4, "Plain object input is allowed only when all elements of tuple are named");

        case 9:
          unusedKeys = new Set(Object.keys(input));
          value = [];
          index = 0;

        case 12:
          if (!(index < memberTypes.length)) {
            _context7.next = 26;
            break;
          }

          //note we had better process these in order!
          memberName = memberTypes[index].name;

          if (memberName in input) {
            _context7.next = 16;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 4, "Missing key from tuple or struct: ".concat(memberName));

        case 16:
          unusedKeys.delete(memberName);
          _context7.t0 = value;
          _context7.t1 = memberName;
          return _context7.delegateYield(wrap(memberTypes[index].type, input[memberName], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(memberName),
            specificityFloor: 4 //not sure this warrants a 5

          })), "t2", 20);

        case 20:
          _context7.t3 = _context7.t2;
          _context7.t4 = {
            name: _context7.t1,
            value: _context7.t3
          };

          _context7.t0.push.call(_context7.t0, _context7.t4);

        case 23:
          index++;
          _context7.next = 12;
          break;

        case 26:
          if (wrapOptions.loose) {
            _context7.next = 30;
            break;
          }

          if (!(unusedKeys.size > 0)) {
            _context7.next = 30;
            break;
          }

          //choose one arbitrarily
          exampleKey = unusedKeys.values().next().value;
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 4, "Unknown key ".concat(exampleKey, " included"));

        case 30:
          return _context7.abrupt("return", {
            type: dataType,
            kind: "value",
            value: value
          });

        case 31:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function tupleFromCodecTupleLikeValue(dataType, input, wrapOptions) {
  var coercedInput;
  return _regeneratorRuntime.wrap(function tupleFromCodecTupleLikeValue$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context8.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "tuple" && input.type.typeClass !== "struct")) {
            _context8.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "value")) {
            _context8.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 6:
          //not going to do much typechecking here as it'll be handled in the call
          //to tupleFromArray
          //Typescript complains if I try to say it can be either struct or
          //tuple, so, uh, let's just tell it it's a tuple <shrug>
          coercedInput = input; //HACK!
          //note that we do *not* just copy over input.value, but rather we
          //defer to tupleFromArray; this is because there might be some elements
          //where the type is not the same but is compatible

          return _context8.delegateYield(tupleFromArray(dataType, coercedInput.value.map(function (_ref2) {
            var value = _ref2.value;
            return value;
          }), wrapOptions), "t0", 8);

        case 8:
          return _context8.abrupt("return", _context8.t0);

        case 9:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function tupleFromTypeValueInput(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function tupleFromTypeValueInput$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (Utils.isTypeValueInput(input)) {
            _context9.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a type/value pair");

        case 2:
          if (!(input.type !== "tuple" && input.type !== "struct")) {
            _context9.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.specifiedTypeMessage(input.type));

        case 4:
          return _context9.delegateYield(dispatch_1.wrapWithCases(dataType, input.value, wrapOptions, tupleCasesBasic), "t0", 5);

        case 5:
          return _context9.abrupt("return", _context9.t0);

        case 6:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function tupleFailureCase(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function tupleFailureCase$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 2, "Input was not an array, plain object, type/value pair or wrapped tuple or struct");

        case 1:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function memberTypesForType(dataType, userDefinedTypes) {
  switch (dataType.typeClass) {
    case "tuple":
      return dataType.memberTypes;
      break;

    case "struct":
      debug("wrapping for struct %s", dataType.typeName);
      return Format.Types.fullType(dataType, userDefinedTypes).memberTypes;
  }
} //udvt cases


function udvtFromUnderlying(dataType, input, wrapOptions) {
  var _Format$Types$fullTyp, underlyingType, value;

  return _regeneratorRuntime.wrap(function udvtFromUnderlying$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _Format$Types$fullTyp = Format.Types.fullType(dataType, wrapOptions.userDefinedTypes), underlyingType = _Format$Types$fullTyp.underlyingType;
          return _context11.delegateYield(wrap(underlyingType, input, wrapOptions), "t0", 2);

        case 2:
          value = _context11.t0;
          return _context11.abrupt("return", {
            type: dataType,
            kind: "value",
            value: value
          });

        case 4:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
} //tx options cases


function optionsFromObject(dataType, input, wrapOptions) {
  var value, uintKeys, uint8Keys, addressKeys, bytesKeys, boolKeys, accessListKeys, specialKeys, allKeys, badKey, goodKey, _i, _uintKeys, key, wrappedOption, _i2, _uint8Keys, _key, _wrappedOption, asBN, _i3, _addressKeys, _key2, _wrappedOption2, _i4, _bytesKeys, _key3, _wrappedOption3, _i5, _boolKeys, _key4, _wrappedOption4, _i6, _accessListKeys, _key5, _wrappedOption5;

  return _regeneratorRuntime.wrap(function optionsFromObject$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (Utils.isPlainObject(input)) {
            _context12.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a non-null object");

        case 2:
          debug("options input is object: %O", input);
          debug("wrapOptions: %O", wrapOptions);

          if (!(!wrapOptions.loose && Utils.isWrappedResult(input))) {
            _context12.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was a wrapped result");

        case 6:
          //now... the main case
          value = {};
          uintKeys = ["gas", "gasPrice", "value", "nonce", "maxFeePerGas", "maxPriorityFeePerGas"];
          uint8Keys = ["type"];
          addressKeys = ["from", "to"];
          bytesKeys = ["data"];
          boolKeys = ["overwrite"];
          accessListKeys = ["accessList"];
          specialKeys = ["privateFor"];
          allKeys = [].concat(uintKeys, uint8Keys, addressKeys, bytesKeys, boolKeys, accessListKeys, specialKeys);
          badKey = Object.keys(input).find(function (key) {
            return !allKeys.includes(key);
          });
          goodKey = Object.keys(input).find(function (key) {
            return allKeys.includes(key);
          });

          if (!(badKey !== undefined && !wrapOptions.oldOptionsBehavior)) {
            _context12.next = 19;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 4, "Transaction options included unknown option ".concat(badKey));

        case 19:
          if (!(wrapOptions.oldOptionsBehavior && goodKey === undefined)) {
            _context12.next = 21;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 4, "Transaction options included no recognized options");

        case 21:
          _i = 0, _uintKeys = uintKeys;

        case 22:
          if (!(_i < _uintKeys.length)) {
            _context12.next = 31;
            break;
          }

          key = _uintKeys[_i];

          if (!(input[key] !== undefined)) {
            _context12.next = 28;
            break;
          }

          return _context12.delegateYield(dispatch_1.wrapWithCases({
            typeClass: "uint",
            bits: 256
          }, input[key], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(key)
          }), integer_1.integerCases), "t0", 26);

        case 26:
          wrappedOption = _context12.t0;
          value[key] = wrappedOption.value.asBN;

        case 28:
          _i++;
          _context12.next = 22;
          break;

        case 31:
          _i2 = 0, _uint8Keys = uint8Keys;

        case 32:
          if (!(_i2 < _uint8Keys.length)) {
            _context12.next = 44;
            break;
          }

          _key = _uint8Keys[_i2];

          if (!(input[_key] !== undefined)) {
            _context12.next = 41;
            break;
          }

          return _context12.delegateYield(dispatch_1.wrapWithCases({
            typeClass: "uint",
            bits: 8
          }, input[_key], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(_key)
          }), integer_1.integerCases), "t1", 36);

        case 36:
          _wrappedOption = _context12.t1;
          asBN = _wrappedOption.value.asBN; //since this is just type right now, we're going to reject illegal types

          if (!asBN.gten(0xc0)) {
            _context12.next = 40;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, "".concat(wrapOptions.name, ".type"), 4, "Transaction types must be less than 0xc0");

        case 40:
          //for compatibility, we give type as a hex string rather than
          //leaving it as a BN.  Since it's unsigned we don't have to
          //worry about negatives.
          value[_key] = Conversion.toHexString(asBN);

        case 41:
          _i2++;
          _context12.next = 32;
          break;

        case 44:
          _i3 = 0, _addressKeys = addressKeys;

        case 45:
          if (!(_i3 < _addressKeys.length)) {
            _context12.next = 54;
            break;
          }

          _key2 = _addressKeys[_i3];

          if (!(input[_key2] !== undefined)) {
            _context12.next = 51;
            break;
          }

          return _context12.delegateYield(dispatch_1.wrapWithCases({
            typeClass: "address",
            kind: "general"
          }, input[_key2], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(_key2)
          }), address_1.addressCases), "t2", 49);

        case 49:
          _wrappedOption2 = _context12.t2;
          value[_key2] = _wrappedOption2.value.asAddress;

        case 51:
          _i3++;
          _context12.next = 45;
          break;

        case 54:
          _i4 = 0, _bytesKeys = bytesKeys;

        case 55:
          if (!(_i4 < _bytesKeys.length)) {
            _context12.next = 64;
            break;
          }

          _key3 = _bytesKeys[_i4];

          if (!(input[_key3] !== undefined)) {
            _context12.next = 61;
            break;
          }

          return _context12.delegateYield(dispatch_1.wrapWithCases({
            typeClass: "bytes",
            kind: "dynamic"
          }, input[_key3], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(_key3)
          }), bytes_1.bytesCases), "t3", 59);

        case 59:
          _wrappedOption3 = _context12.t3;
          value[_key3] = _wrappedOption3.value.asHex;

        case 61:
          _i4++;
          _context12.next = 55;
          break;

        case 64:
          _i5 = 0, _boolKeys = boolKeys;

        case 65:
          if (!(_i5 < _boolKeys.length)) {
            _context12.next = 74;
            break;
          }

          _key4 = _boolKeys[_i5];

          if (!(input[_key4] !== undefined)) {
            _context12.next = 71;
            break;
          }

          return _context12.delegateYield(dispatch_1.wrapWithCases({
            typeClass: "bool"
          }, input[_key4], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(_key4)
          }), bool_1.boolCases), "t4", 69);

        case 69:
          _wrappedOption4 = _context12.t4;
          value[_key4] = _wrappedOption4.value.asBoolean;

        case 71:
          _i5++;
          _context12.next = 65;
          break;

        case 74:
          _i6 = 0, _accessListKeys = accessListKeys;

        case 75:
          if (!(_i6 < _accessListKeys.length)) {
            _context12.next = 84;
            break;
          }

          _key5 = _accessListKeys[_i6];

          if (!(input[_key5] !== undefined)) {
            _context12.next = 81;
            break;
          }

          return _context12.delegateYield(dispatch_1.wrapWithCases({
            typeClass: "array",
            kind: "dynamic",
            baseType: {
              typeClass: "tuple",
              memberTypes: [{
                name: "address",
                type: {
                  typeClass: "address",
                  kind: "general"
                }
              }, {
                name: "storageKeys",
                type: {
                  typeClass: "array",
                  kind: "dynamic",
                  baseType: {
                    //we use uint256 rather than bytes32 to allow
                    //abbreviating and left-padding
                    typeClass: "uint",
                    bits: 256
                  }
                }
              }]
            }
          }, input[_key5], Object.assign(Object.assign({}, wrapOptions), {
            name: "".concat(wrapOptions.name, ".").concat(_key5)
          }), exports.arrayCases), "t5", 79);

        case 79:
          _wrappedOption5 = _context12.t5;
          value[_key5] = Format.Utils.Inspect.nativizeAccessList(_wrappedOption5);

        case 81:
          _i6++;
          _context12.next = 75;
          break;

        case 84:
          if (!(input.privateFor !== undefined)) {
            _context12.next = 88;
            break;
          }

          if (Array.isArray(input.privateFor)) {
            _context12.next = 87;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, "".concat(wrapOptions.name, ".privateFor"), 4, "Transaction option privateFor should be an array of base64-encoded bytestrings of 32 bytes");

        case 87:
          value.privateFor = input.privateFor.map(function (publicKey, index) {
            if (Utils.isBoxedString(publicKey)) {
              publicKey = publicKey.valueOf();
            }

            if (typeof publicKey !== "string") {
              throw new errors_1.TypeMismatchError(dataType, input, "".concat(wrapOptions.name, ".privateFor"), 4, "Public key at index ".concat(index, " is not a string"));
            }

            if (!Utils.isBase64(publicKey)) {
              throw new errors_1.TypeMismatchError(dataType, input, "".concat(wrapOptions.name, ".privateFor"), 4, "Public key at index ".concat(index, " is not base64-encoded"));
            }

            var length = Utils.base64Length(publicKey);

            if (length !== 32) {
              throw new errors_1.TypeMismatchError(dataType, input, "".concat(wrapOptions.name, ".privateFor"), 4, "Public key at index ".concat(index, " should encode a bytestring of 32 bytes; got ").concat(length, " bytes instead"));
            }

            return publicKey;
          });

        case 88:
          return _context12.abrupt("return", {
            type: dataType,
            kind: "value",
            value: value
          });

        case 89:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function optionsFromCodecOptionsValue(dataType, input, wrapOptions) {
  var value;
  return _regeneratorRuntime.wrap(function optionsFromCodecOptionsValue$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context13.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "options")) {
            _context13.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "value")) {
            _context13.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 6:
          value = input.value; //unlike in the array or tuple cases, here should not have
          //to worry about compatible-but-not-identical types, so it's
          //safe to just copy value over

          return _context13.abrupt("return", {
            type: dataType,
            kind: "value",
            value: value
          });

        case 8:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function optionsFromTypeValueInput(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function optionsFromTypeValueInput$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          if (Utils.isTypeValueInput(input)) {
            _context14.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a type/value pair");

        case 2:
          if (!(input.type !== "options")) {
            _context14.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.specifiedTypeMessage(input.type));

        case 4:
          return _context14.delegateYield(dispatch_1.wrapWithCases(dataType, input.value, Object.assign(Object.assign({}, wrapOptions), {
            loose: true
          }), txOptionsCasesBasic), "t0", 5);

        case 5:
          return _context14.abrupt("return", _context14.t0);

        case 6:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

function optionsFailureCase(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function optionsFailureCase$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 2, "Transaction options input was not a plain object, type/value pair or wrapped options object");

        case 1:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}